import { render, staticRenderFns } from "./PublicInfoEdit.vue?vue&type=template&id=07622b04&"
import script from "./PublicInfoEdit.vue?vue&type=script&lang=ts&"
export * from "./PublicInfoEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports